import { Axios, AxiosService } from '@/services/Axios';

import { ProposalType } from './types';

export class ProposalControllerClass {
  constructor(private APIService: AxiosService) {}

  fetchProposal = (id: string) => {
    return this.APIService.get(`/proposals/${id}`);
  };

  fetchProposalMetrics = (dateOption: string) => {
    return this.APIService.get(`/metrics/opportunities?period=${dateOption}`);
  };

  fetchProposalMetricsDates = (dateOption: string) => {
    return this.APIService.get(`/periodfiscaldate/dates?period=${dateOption}`);
  };

  savePrice = (proposalId: string, proposalPriceDetails: ProposalType) => {
    const updateProposalPriceURL = `/proposals/${proposalId}/update-price`;

    return this.APIService.put(updateProposalPriceURL, proposalPriceDetails);
  };
}

export const ProposalController = new ProposalControllerClass(Axios);
